import {
  CommittedLoadConnection,
  CommittedLoadStatus,
  IHasCommittedLoad,
} from "../model/viewModel/committedLoad";
import { Asset } from "../model/viewModel/asset";
import { Transformer } from "../model/viewModel/transformer";

export const committedLoadFilter = (
  item: CommittedLoadConnection,
  includeCommittedLoadQuotationSent: boolean,
) => includeCommittedLoadQuotationSent || item.status !== CommittedLoadStatus.QuotationSent;

export const assetIsTransformer = (asset: Asset): asset is Transformer =>
  asset.styles.type === "transformer";

export const transformerHasDisplayedCommittedLoad = (
  transformer: IHasCommittedLoad,
  includeCommittedLoadQuotationSent: boolean,
) =>
  transformer.committedLoad?.connections.some((item) =>
    committedLoadFilter(item, includeCommittedLoadQuotationSent),
  ) ?? false;

export const transformerHasCommittedLoadConnections = (transformer: IHasCommittedLoad) =>
  transformer.committedLoad?.totalConnections > 0;

export const getStatusDisplayText = (status: CommittedLoadStatus) => {
  switch (status) {
    case CommittedLoadStatus.AcceptedNotYetConnected:
      return "Accepted Not Yet Connected";
    case CommittedLoadStatus.QuotationSent:
      return "Quotation Sent";
    default:
      return "Unknown";
  }
};

export const getDateDisplayText = (date: string) => new Date(date).toLocaleDateString("en-GB");
